// Feature flag + time-of-day artwork for the NextBell hero background.
//
// When the flag is ON, the hero card shows an animated GIF that changes with the
// real-world time of day (morning / daytime / evening / night). When OFF, the
// hero keeps its original solid blue gradient. The flag is stored in
// localStorage so it survives reloads and can be toggled at runtime; a custom
// event lets the hero react live without a page refresh.

import morningGif from "../assets/gif/hero-r1-good-morning.gif";
import daytimeGif from "../assets/gif/hero-r2-daytime.gif";
import eveningGif from "../assets/gif/hero-r3-good-evening.gif";
import nightGif from "../assets/gif/hero-r4-good-night.gif";

export const HERO_ANIMATION_STORAGE_KEY = "heroAnimationEnabled";
export const HERO_ANIMATION_UPDATED_EVENT = "hero:animation-updated";

// Change this to flip the out-of-the-box behaviour when nothing is stored yet.
const HERO_ANIMATION_DEFAULT = true;

export const isHeroAnimationEnabled = () => {
    try {
        const raw = localStorage.getItem(HERO_ANIMATION_STORAGE_KEY);
        if (raw === null) {
            return HERO_ANIMATION_DEFAULT;
        }
        return raw === "true";
    } catch (e) {
        return HERO_ANIMATION_DEFAULT;
    }
};

export const setHeroAnimationEnabled = (enabled) => {
    const value = !!enabled;
    try {
        localStorage.setItem(HERO_ANIMATION_STORAGE_KEY, String(value));
    } catch (e) {
        // localStorage unavailable — still notify listeners for this session.
    }
    window.dispatchEvent(
        new CustomEvent(HERO_ANIMATION_UPDATED_EVENT, {detail: {enabled: value}})
    );
    return value;
};

// Resolve which GIF to show for a given moment. Boundaries:
//   morning  05:00–10:59, daytime 11:00–16:59,
//   evening  17:00–19:59, night   20:00–04:59.
export const getHeroGifForTime = (date = new Date()) => {
    const hour = date.getHours();
    if (hour >= 5 && hour < 11) {
        return morningGif;
    }
    if (hour >= 11 && hour < 17) {
        return daytimeGif;
    }
    if (hour >= 17 && hour < 20) {
        return eveningGif;
    }
    return nightGif;
};

// Convenience runtime toggles from the browser console:
//   window.setHeroAnimation(true) / window.setHeroAnimation(false)
if (typeof window !== "undefined") {
    window.setHeroAnimation = setHeroAnimationEnabled;
}
